import { render, staticRenderFns } from "./UploadImportFile.vue?vue&type=template&id=c1232f22"
import script from "./UploadImportFile.vue?vue&type=script&lang=js"
export * from "./UploadImportFile.vue?vue&type=script&lang=js"
import style0 from "./UploadImportFile.vue?vue&type=style&index=0&id=c1232f22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports